export default "__VITE_ASSET__CYl3PtAs__"